import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome.component.html'
})

export class WelcomeComponent implements OnInit {
    canEditWizard = false;

    constructor(
        private authService: AuthService,
    ) {

    }

    ngOnInit() {
        this.canEditWizard = this.authService.hasPermissions([
            UserNamespace.Permission.wizardDocumentsCreate,
            UserNamespace.Permission.wizardDocumentsUpdate,
            /**
             * Если не может просматривать копии документов, то и в визарде делать нечего
             */
            UserNamespace.Permission.structureUnitDocumentList,
        ]);
    }
}
